(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auv-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.auv-bb').forEach(function (root) {
      /* gallery */
      var strip = root.querySelector('.auv-bb__thumbs');
      var main = strip ? document.getElementById(strip.dataset.main) : null;
      if (strip && main) {
        var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.auv-bb__thumb'));
        function activate(i) {
          if (i < 0) i = thumbs.length - 1; if (i >= thumbs.length) i = 0;
          var b = thumbs[i]; if (!b) return;
          main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = b.dataset.src;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); }); b.classList.add('is-active');
          b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
        strip.addEventListener('click', function (e) { var b = e.target.closest('.auv-bb__thumb'); if (b) activate(thumbs.indexOf(b)); });
        root.querySelectorAll('.auv-bb__gbtn').forEach(function (a) {
          a.addEventListener('click', function () { var c = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); activate(a.dataset.dir === 'next' ? c + 1 : c - 1); });
        });
        var stage = root.querySelector('.auv-bb__card') || main, sx = 0, sy = 0, tr = false;
        function ci() { return thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); }
        stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; tr = true; }, { passive: true });
        stage.addEventListener('touchend', function (e) { if (!tr) return; tr = false; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) activate(dx < 0 ? ci() + 1 : ci() - 1); }, { passive: true });
        stage.style.touchAction = 'pan-y';
      }

      /* dosage toggle (visual) */
      root.querySelectorAll('.auv-bb__dose').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('.auv-bb__dose').forEach(function (d) { d.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      /* bundle selector + ATC price */
      var qtyInput = root.querySelector('[data-qty-input]');
      var planInput = root.querySelector('[data-plan-input]');
      var offerInput = root.querySelector('[data-offer-input]');
      var giftsInput = root.querySelector('[data-gifts-input]');
      var regularInput = root.querySelector('[data-regular-input]');
      var atcPrice = root.querySelector('[data-atc-price]');
      var atcCompare = root.querySelector('[data-atc-compare]');
      var atcSave = root.querySelector('[data-atc-save]');

      function currentOffer() { return root.querySelector('.auv-offer__input:checked'); }
      function update() {
        var r = currentOffer();
        /* both options are a single unit of the real variant, so quantity is always 1 */
        if (qtyInput) qtyInput.value = '1';
        if (atcPrice) atcPrice.textContent = r ? (r.dataset.price || '') : '';
        if (atcSave) atcSave.textContent = (r && r.dataset.save) ? '\u00b7 ' + r.dataset.save : '';
        if (atcCompare) atcCompare.textContent = '';
        /* the selling plan rides on the subscription option only -- never on one-time */
        if (planInput) {
          var plan = (r && r.value === 'sub' && r.dataset.plan) ? r.dataset.plan : '';
          if (plan) { planInput.value = plan; planInput.disabled = false; }
          else { planInput.value = ''; planInput.disabled = true; }
        }
        if (offerInput) {
          if (r && r.dataset.offer) { offerInput.value = r.dataset.offer; offerInput.disabled = false; }
          else { offerInput.value = ''; offerInput.disabled = true; }
        }
        if (giftsInput) {
          if (r) { giftsInput.value = r.dataset.gifts || '0'; giftsInput.disabled = false; }
          else { giftsInput.value = ''; giftsInput.disabled = true; }
        }
        /* On a subscription, hand the cart drawer the one-time price as the
           comparison basis so its summary reads One-time price / Subscription
           savings / Total savings against the real offer. Without it the drawer
           falls back to the variant's compare-at price, which is a different
           number entirely. One-time orders send nothing -- there is nothing to
           compare against. */
        if (regularInput) {
          var oneEl = root.querySelector('.auv-offer__input[value="one"]');
          var oneNum = oneEl ? parseFloat(String(oneEl.dataset.price || '').replace(/[^0-9.]/g, '')) : NaN;
          if (r && r.value === 'sub' && !isNaN(oneNum) && oneNum > 0) {
            regularInput.value = oneNum.toFixed(2); regularInput.disabled = false;
          } else { regularInput.value = ''; regularInput.disabled = true; }
        }
        root.querySelectorAll('.auv-offer__card').forEach(function (c) { c.classList.remove('is-selected'); });
        var card = r ? r.closest('.auv-offer__card') : null;
        if (card) card.classList.add('is-selected');
      }
      root.querySelectorAll('.auv-offer__input').forEach(function (radio) {
        radio.addEventListener('change', update);
      });
      /* the card is a div, so make the whole card selectable, not just the band label */
      root.querySelectorAll('[data-card]').forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a, button')) return;
          var input = card.querySelector('.auv-offer__input');
          if (input && !input.checked) { input.checked = true; update(); }
        });
      });
      update();

      /* evergreen countdown */
      var cd = root.querySelector('[data-countdown]');
      if (cd) {
        var mins = parseInt(cd.dataset.minutes, 10) || 480;
        var key = 'auv_cd_' + mins;
        var ch = cd.querySelector('[data-h]'), cm = cd.querySelector('[data-m]'), cs = cd.querySelector('[data-s]');
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tickCd = function () {
          var dl = parseInt(localStorage.getItem(key) || '0', 10);
          if (!dl || dl < Date.now()) { dl = Date.now() + mins * 60000; localStorage.setItem(key, String(dl)); }
          var t = Math.floor(Math.max(0, dl - Date.now()) / 1000);
          if (ch) ch.textContent = pad(Math.floor(t / 3600));
          if (cm) cm.textContent = pad(Math.floor((t % 3600) / 60));
          if (cs) cs.textContent = pad(t % 60);
        };
        tickCd(); setInterval(tickCd, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auv-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('auv-cart-drawer');
    if (!root || root.dataset.auvcdInit) return;
    root.dataset.auvcdInit = '1';

    var cur = root.dataset.currency || 'USD';
    var eyebrowDefault = root.dataset.eyebrow || '';
    var subPillText = root.dataset.subpill || 'Subscription Savings Applied';

    var linesEl = root.querySelector('[data-lines]');
    var emptyEl = root.querySelector('[data-empty]');
    var giftsEl = root.querySelector('[data-gifts]');
    var summaryEl = root.querySelector('[data-summary]');
    var footerEl = root.querySelector('[data-footer]');
    var itemsEl = root.querySelector('[data-items]');

    function fmt(cents, dropZero) {
      var v = (cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: cur,
          minimumFractionDigits: (dropZero && v % 1 === 0) ? 0 : 2,
          maximumFractionDigits: 2
        }).format(v);
      } catch (e) {
        return '$' + v.toFixed(dropZero && v % 1 === 0 ? 0 : 2);
      }
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* ---------- open / close ---------- */
    function open() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.classList.add('auvcd-lock');
      document.body.classList.add('auvcd-lock');
    }
    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('auvcd-lock');
      document.body.classList.remove('auvcd-lock');
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    /* ---------- render ---------- */
    function lineHTML(item, index) {
      var alloc = item.selling_plan_allocation;
      var isSub = !!alloc;
      var props = item.properties || {};
      var offerName = props._offer || '';
      var eyebrow = offerName || ((isSub && alloc.selling_plan && alloc.selling_plan.name) ? alloc.selling_plan.name : eyebrowDefault);
      var original = item.original_price != null ? item.original_price : item.price;
      var final = item.final_price != null ? item.final_price : item.price;
      var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || '');
      var html = '';
      html += '<div class="auvcd__line" data-line="' + index + '">';
      if (eyebrow) html += '<p class="auvcd__line-eyebrow">' + esc(eyebrow) + '</p>';
      html += '<div class="auvcd__line-main">';
      html += '<div class="auvcd__line-media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title || item.title) + '">' : '') + '</div>';
      html += '<div class="auvcd__line-info">';
      html += '<h4 class="auvcd__line-title">' + esc(item.product_title || item.title) + '</h4>';
      if (isSub) html += '<span class="auvcd__subpill"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0l-7.2-7.2A2 2 0 013 12V4h8a2 2 0 011.4.6l8.2 8.2a2 2 0 010 2.6z"/><circle cx="7.5" cy="7.5" r="1.3" fill="currentColor"/></svg>' + esc(subPillText) + '</span>';
      html += '<div class="auvcd__line-price"><span class="now">' + fmt(final, false) + '</span>' + (original > final ? '<s>' + fmt(original, false) + '</s>' : '') + '</div>';
      html += '<div class="auvcd__line-controls">';
      html += '<div class="auvcd__stepper"><button type="button" data-dec aria-label="Decrease">&#8722;</button><span class="auvcd__stepper-qty" data-qty>' + item.quantity + '</span><button type="button" data-inc aria-label="Increase">&#43;</button></div>';
      html += '<button type="button" class="auvcd__trash" data-remove aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg></button>';
      html += '</div></div></div></div>';
      return html;
    }

    function render(cart) {
      var count = cart.item_count || 0;
      itemsEl.textContent = count + ' ' + (count === 1 ? 'Item' : 'Items');

      if (!cart.items || cart.items.length === 0) {
        linesEl.innerHTML = '';
        emptyEl.hidden = false;
        if (giftsEl) giftsEl.hidden = true;
        if (summaryEl) summaryEl.hidden = true;
        if (footerEl) footerEl.hidden = true;
        root.querySelectorAll('.auvcd__rule, .auvcd__review').forEach(function (el) { el.hidden = true; });
        return;
      }
      emptyEl.hidden = true;
      if (summaryEl) summaryEl.hidden = false;
      if (footerEl) footerEl.hidden = false;
      root.querySelectorAll('.auvcd__rule, .auvcd__review').forEach(function (el) { el.hidden = false; });

      // Show free gifts only for offers that include them (Buy 2 Get 1 Free, Buy 3 Get 2 Free).
      var showGifts = false;
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (p._gifts === '1' || p._gifts === 1) showGifts = true;
        else if (!('_gifts' in p) && it.quantity >= 3) showGifts = true;
      });
      if (giftsEl) giftsEl.hidden = !showGifts;
      var giftsRule = root.querySelector('[data-gifts-rule]');
      if (giftsRule) giftsRule.hidden = !showGifts;

      linesEl.innerHTML = cart.items.map(function (it, i) { return lineHTML(it, i + 1); }).join('');

      var original = 0, final = 0;
      cart.items.forEach(function (it) {
        final += (it.final_line_price != null ? it.final_line_price : it.line_price);
        // "One-time price" = per-bag one-time price × qty, carried from the chosen offer.
        var p = it.properties || {};
        var reg;
        var ru = p._regular_unit ? parseFloat(p._regular_unit) : 0;
        if (ru > 0) reg = Math.round(ru * 100) * it.quantity;
        else if (it.compare_at_price && it.compare_at_price > it.final_price) reg = it.compare_at_price * it.quantity;
        else reg = (it.original_line_price != null ? it.original_line_price : it.line_price);
        original += reg;
      });
      var savings = original - final;

      root.querySelector('[data-sum-original]').textContent = fmt(original, true);
      root.querySelector('[data-sum-subtotal]').textContent = fmt(final, true);

      /* A cart with no selling plan is a plain one-time order. There is no
         recurring price to compare against, so the summary shows the subtotal
         alone -- otherwise the variant's compare-at price manufactures a
         "saving" the customer is not actually getting. */
      var hasSubscription = cart.items.some(function (it) { return !!it.selling_plan_allocation; });
      var originalRow = root.querySelector('[data-original-row]');
      if (originalRow) originalRow.hidden = !hasSubscription;

      var savingsRow = root.querySelector('[data-savings-row]');
      var totalSavingsRow = root.querySelector('[data-total-savings-row]');
      var footPct = root.querySelector('[data-foot-pct]');
      var footCompare = root.querySelector('[data-foot-compare]');

      if (savings > 0 && hasSubscription) {
        savingsRow.hidden = false; totalSavingsRow.hidden = false;
        root.querySelector('[data-sum-savings]').textContent = '-' + fmt(savings, true);
        root.querySelector('[data-sum-total-savings]').textContent = '-' + fmt(savings, true);
        var pct = Math.round(savings / original * 100);
        footPct.hidden = false; footPct.textContent = pct + '% OFF';
        footCompare.hidden = false; footCompare.textContent = fmt(original, true);
      } else {
        savingsRow.hidden = true; totalSavingsRow.hidden = true;
        footPct.hidden = true; footCompare.hidden = true;
      }
      root.querySelector('[data-foot-price]').textContent = fmt(final, true);
    }

    /* ---------- cart ops ---------- */
    function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    function changeLine(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }
    function refresh() { return getCart().then(render); }

    linesEl.addEventListener('click', function (e) {
      var lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      var line = parseInt(lineEl.dataset.line, 10);
      var qtyEl = lineEl.querySelector('[data-qty]');
      var qty = parseInt(qtyEl.textContent, 10) || 1;
      var next = null;
      if (e.target.closest('[data-inc]')) next = qty + 1;
      else if (e.target.closest('[data-dec]')) next = qty - 1;
      else if (e.target.closest('[data-remove]')) next = 0;
      if (next === null) return;
      lineEl.style.opacity = '0.5';
      changeLine(line, next).then(render).catch(function () { refresh(); });
    });

    /* ---------- add to cart (intercept custom buy box) ---------- */
    function addForm(form) {
      var fd = new FormData(form);
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { open(); });
    }
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.classList && form.classList.contains('auv-bb__form')) {
        e.preventDefault();
        var btn = form.querySelector('[data-atc]');
        if (btn) { btn.disabled = true; }
        addForm(form).catch(function () { form.submit(); }).then(function () { if (btn) btn.disabled = false; });
      }
    }, true);

    /* ---------- header cart trigger ---------- */
    document.querySelectorAll('[data-testid="cart-drawer-trigger"], a[href="/cart"], a[href$="/cart"]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        refresh().then(open);
      }, true);
    });

    /* expose + initial fill */
    window.auvCartDrawer = { open: function () { refresh().then(open); }, close: close, refresh: refresh };
    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auv-education"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.auv-ed').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.auv-ed__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.auv-ed__panel'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.dataset.tab;
          tabs.forEach(function (t) { var on = t.dataset.tab === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === i); });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auv-header"] && !Shopify.designMode) return;
  try {
    
  class AuvHeader extends HTMLElement {
    connectedCallback() {
      var b = this.querySelector('.auv-hd__burger'), d = this.querySelector('.auv-hd__drawer');
      if (b && d) b.addEventListener('click', function () { var open = d.hasAttribute('hidden'); if (open) d.removeAttribute('hidden'); else d.setAttribute('hidden',''); b.setAttribute('aria-expanded', String(open)); });
    }
  }
  if (!customElements.get('auv-header')) customElements.define('auv-header', AuvHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auv-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.auv-rv').forEach(function (root) {
      var track = root.querySelector('[data-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.auv-rv__card'));
      var dotsWrap = root.querySelector('[data-dots]');
      if (dotsWrap) {
        cards.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'auv-rv__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to review ' + (i + 1));
          dotsWrap.appendChild(d);
        });
      }
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.auv-rv__dot')) : [];
      function cardW() { var c = cards[0]; if (!c) return track.clientWidth; var s = getComputedStyle(track); var gap = parseFloat(s.columnGap || s.gap || 16) || 16; return c.offsetWidth + gap; }
      function idx() { return Math.round(track.scrollLeft / cardW()); }
      function setActive(i) { dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }
      track.addEventListener('scroll', function () { setActive(Math.max(0, Math.min(cards.length - 1, idx()))); }, { passive: true });
      root.querySelectorAll('.auv-rv__arrow').forEach(function (a) {
        a.addEventListener('click', function () {
          var i = idx() + (a.dataset.dir === 'next' ? 1 : -1);
          i = Math.max(0, Math.min(cards.length - 1, i));
          track.scrollTo({ left: i * cardW(), behavior: 'smooth' });
        });
      });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { track.scrollTo({ left: i * cardW(), behavior: 'smooth' }); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auv-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.auv-st').forEach(function (root) {
      var track = root.querySelector('[data-track]'); if (!track) return;
      var pages = Array.prototype.slice.call(track.querySelectorAll('.auv-st__page'));
      var dotsWrap = root.querySelector('[data-dots]');
      if (pages.length < 2) { var nav = root.querySelector('[data-nav]'); if (nav) nav.style.display = 'none'; return; }
      if (dotsWrap) { pages.forEach(function (_, i) { var d = document.createElement('button'); d.type='button'; d.className='auv-st__dot'+(i===0?' is-active':''); d.setAttribute('aria-label','Slide '+(i+1)); dotsWrap.appendChild(d); }); }
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.auv-st__dot')) : [];
      function pageW(){ return pages[0] ? pages[0].offsetWidth : track.clientWidth; }
      function idx(){ return Math.round(track.scrollLeft / pageW()); }
      track.addEventListener('scroll', function(){ var i=Math.max(0,Math.min(pages.length-1,idx())); dots.forEach(function(d,j){ d.classList.toggle('is-active', j===i); }); }, {passive:true});
      dots.forEach(function(d,i){ d.addEventListener('click', function(){ track.scrollTo({left:i*pageW(),behavior:'smooth'}); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auv-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.auv-tl').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.auv-tl__tab'));
      function groups(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
      var sets = [groups('[data-tl-dot]'), groups('[data-tl-bubble]'), groups('[data-tl-xlabel]'), groups('[data-tl-panel]')];
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.getAttribute('data-tl-tab');
          tabs.forEach(function (t) { var on = t.getAttribute('data-tl-tab') === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          sets.forEach(function (list) {
            list.forEach(function (el) {
              var key = el.getAttribute('data-tl-dot') || el.getAttribute('data-tl-bubble') || el.getAttribute('data-tl-xlabel') || el.getAttribute('data-tl-panel');
              el.classList.toggle('is-active', key === i);
            });
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
